import type { AxiosResponse } from 'axios';
import pino from 'pino';

import { getBrowserEnv, getNodeEnv, isBrowser, isDev } from '../utils/env';
export interface LogProps {
  message: string;
  // node层api请求&错误记录
  type: 'api_error' | 'api_access';
  res: AxiosResponse;
  error?: Error;
  isError?: boolean; // 新增
  extra?: Record<string, unknown>;
}

const logLevel = 'info';

const logger = isDev
  ? {
      info: console.info,
      error: console.error,
    }
  : pino({
      name: 'talkie-next',
      level: logLevel,
      base: {
        env: isBrowser ? getBrowserEnv() : getNodeEnv(),
      },
    });

export function loggerEvent<T extends LogProps>(props: T & LogProps) {
  const logProps = {
    message: props.message,
    type: props.type,
    req: {
      url: props.res.config.url,
      method: props.res.config.method,
      params: props.res.config.params,
      body: props.res.config.data,
      headers: props.res.config.headers,
    },
    res: {
      status: props.res.status,
      data: props.res.data,
      headers: props.res.headers,
    },
    ...props.extra,
  };

  if (!isDev) delete logProps['res']['data'];

  if (props.isError || props.error) {
    logger.error(logProps, props.message);
  } else {
    logger.info(logProps, props.message);
  }
}

export { logger };
